import styled from '@emotion/styled'

export const headerText = 'Expert Business Advice'
export const descriptionText =
	'Unlock the expertise in key topics like finance, marketing, HR and more to steady your business in challenging times and grow to the next level.'

export const EmailSignUpContainer = styled.div`
	background: ${({ theme }) => theme.colors.gray[200]};
	padding: 1rem 1.5rem;
	margin-top: 1rem;
	max-width: 1000px;
	width: 100%;

	${({ theme }) => theme.MQ.XL} {
		flex-direction: row;
		margin: 2rem 0;
	}
`
export const FormContainer = styled.div`
	width: 100%;
	${({ theme }) => theme.MQ.XL} {
		border-left: 1px solid white;
		margin-left: 0.5rem;
		padding-left: 1.5rem;
		width: 50%;
	}
`
